import { HttpGet } from "../utils/request";

export function marketData(frequency, date) {
     return HttpGet(`/api/v3/mfmarket?frequency=${frequency}&date=${date}`)
}